import { EPOCUS_ICON_ACTIVE } from "./epocus-palette";

export const ScoreSparkline: FC<{
  data: number[];
  color?: string;
  width?: number;
  height?: number;
}> = ({ data, color = EPOCUS_ICON_ACTIVE, width = 180, height = 40 }) => {
  if (data.length < 2) return null;

  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min || 1;
  const pad = 4;

  const toCoords = (v: number, i: number): [number, number] => [
    pad + (i / (data.length - 1)) * (width - pad * 2),
    height - pad - ((v - min) / range) * (height - pad * 2),
  ];

  const points = data.map((v, i) => toCoords(v, i).join(",")).join(" ");
  const [lastX, lastY] = toCoords(data[data.length - 1], data.length - 1);

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{
        display: "block",
        width: "100%",
        maxWidth: width,
        height: "auto",
      }}
      aria-hidden="true"
    >
      <polyline
        points={points}
        fill="none"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={lastX} cy={lastY} r={3} fill={color} />
    </svg>
  );
};
